<template>
  <div class="container page lottery">
    <van-nav-bar :title="this.lottery.name" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
      <template #right>
        <img @click="$router.push({path:'/GameRecord'});" style="width: 1.5rem;"
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIMSURBVHgB7ZqBcYMwDABFJqATxBs0G7SbMEK6Ad0gI9ENmk6AO0GygSIfNig+QwyOsXPH3/lwziKWZIEdKQAbaSlgAYj4ThdBrdTXECS1q7oWRfEHMSCFS2pHag21C8aloVZR20MoWvF6BaXHOCkdpnQsJpQXdGnAHSKS2hn00kMYAoZwPIzM9Unh9Q++KOWptZY3GuzCqIRI6Hkrx9zqs19IYRc2/AtU+FSwMtqQi2XEY+fpuOPKhz9MC9Erwo2ofW7grO55h06V5dDSV7iFTNDPn+HoK5jc+wbsXh6GZkqQkyz2bbB7sfRhNCZ0YEK/kBl4/2bs94sdk+Eev0J+nFm/15Ub8Mb6EvKDO7V/E42tgIT8kKwvTGcHL85mQGo2A1Kz2AAcjrut69gROr5EoZrtdLWHfDu1vYeO++oXEkL8WHuNMO5FiAFfMKREviOMz2NuCK1NjBDKgs2A1GwGpIYbwFN3AvJDsL40HW4A3w2jpQ8DEKzfb3xjK3CA/OBOdSd68T6Nl80qoJUx5GP2Q8x/+WeT2CI+WP9nVAp9M2ArY51cqynB0gqj3JK7iv2jG2omnFt6/eRz02sXOPTNrhJTi8+qHo7Py6uh9tzOeZcW+XiBT0IYAoYCn3CMS5hb5DNoj5wwDSp8anzGfoRD9bDBuFxwZjV06V8NzHKrSUKfCRUa5q8GZ9h4MW7T6dkxv5SMKwAAAABJRU5ErkJggg==">
      </template>
    </van-nav-bar>
    <div class="record">
      <div class="lotteryMsgBox">
        <div class="lotteryMsg">
          <div class="top">
            <div class="time">
              <div class="sty1">
                <span><span>{{ this.lottery.next_expect }}</span></span>
                {{ $t("代码") }}
              </div>
              <div  class="count_down" style="display: flex;justify-content: center;">
                <van-count-down style="color: rgb(255, 57, 0);" :time="time" @finish="check()"/>
              </div>

            </div>
          </div>
          <div class="ks openInfo">
            <div class="foot">
              <div>
                <div class="periods" @click="active ? active = false : active = true">
                  <span>{{ lottery.now_expect }}</span>{{ $t("代码结果") }}
                  <van-icon style="margin-left: auto;" name="arrow-down" :class="{ up: active,down:!active }"
                           />
                </div>
                <div class="lotteryResult">
                  <div v-for="(item,key) in lottery.opencode" :key="key">{{ item }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="history_popup"></div>
    <div class="wrapper">
      <div class="options-bar">
        <div class="game">
          <div class="linear-gradient"
               style="background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));"></div>
          <div class="sumValueTwoSides">
            <div class="rectangle large" v-for="(v,key) in lottery_peilv_list"
                 :key="key" @click="choosePlay(v.type,v.name);">
              <p class="name-text large" :class="{active:choose[v.type]}">{{ names(v.name) }}</p>
            </div>
          </div>

          <img style="width: 100%;margin-bottom: 100px" src="/img/lottery/brands.png">
        </div>
      </div>


      <div class="bottom-bar">
        <div class="bar">
          <div class="left">
            <div class="item" v-if="false" @click="shopping ? shopping = false : shopping = true ">
              <van-icon name="cart-o" class="jixuanico"/>
              {{ $t("choice") }}
            </div>
            <img @click="money=''" style="width: 1rem;margin: 0 10px" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALYSURBVHgB7VfBbtNAEJ3Z2GokKmIuXON8AekXtJw5AGrg3N6RqCtuDcKHhFxQAhL3ckNCbRMOnClfQP6gzhfgKoCoEu8y46xDnMaJnbSCA0+yvWvvzr6dmZ0ZA/xlIGSE6x5axs31TQFoxb8IT0rlVZ9t9yADMhGoN9tPFQav5wpUsHewX3kDV02g0XhvB3nzTHdPaaoXH6Fsum3R5Q+hX3KdXR9SwICUCNbW7gDIcPGqU7k7a0ytdfSZSRiqsEnPjynEgoCUQFTlUUt154wKvyFIG9LKnX4ROtn67QKIn2V2NAVg0erkcGqH2jaM1R+qHOKmiMygugiig0p5EpQvIOcLBf6v/nnPdeOmiRGot47O9CLXBpLvPXcqpahvTH0kdugjseaBenfU5/dB7HhJvXMx1kQkxCwASkvLs2kuaVFxny6kvvLgP9KA/KFdbx2/gBXBwYtlJX2feQwbrbZN9ntAHrwDqwKDPZZVe/upCGkJXIROFx4RC1ZEdKqqT+71UhNwnYfRWV2ZwCIkhmLavcfsWXWT7F82TyjMzo50HHSq+4/GIZhNGUDATT8zgVmoNU/uS5Sd5BFIzvth48B5HAvXahkC0SQc/LhFj1ADQ8QvBiCn40TTKPPGt3FbqSKrEsOglpEAaAJyovDQvuHAFSIxG6IOtaiwCEtCak3hHBOkTsfLANWQzUfmxKWc0AuFINqTL3Vl9BWm/ICTVwD9jVglJHLFcPk5PpBZAxf5PGXHyzuid5ZhUh2REckakJR+hYDp+kA7YgnSweYbnQYvacC1+gCM6gBeJrsTIhq6Ap4qOLIsr/2ESvlzyEpADYfRpFXywcK5iQQGpunpZrn26jhzLODTwnO5HcD3xEp67o8JFSSH6k9NcHr5ZyQJssz1H4zqwHdVZ3s3aeTcZDQA4Zic40YktkKrpgLqO3ZYxuKRC+C22lYOhmWR0iG5Yg7A6E7UFf8ufgPlggLyQ0qLGAAAAABJRU5ErkJggg==" >
            <div class="line"></div>
          </div>
          <div class="mid">
            <div class="part">
              <span>{{ $t("lottery.total") }}</span>
              <b class="number">{{ this.formData.length }}</b>
              <span>{{ $t("lottery.note") }}</span>
              <b class="number">{{ formatNumber(formData.length*money) }}</b>
            </div>
<!--            <span class="text">{{ $t("lottery.money") }}</span>
            <span class="text num">{{ this.userInfo.money * 1 }} K</span>
            <span class="text"></span>-->
          </div>
          <div class="right" @click="jiesuan()" :style="formData.length*money > 0?'':'opacity: .5;'">
            {{ $t("lottery.submit") }}
          </div>
        </div>

        <div class="wrapper setting active">
          <div class="setMoney">
            <div class="keyboardInput">
              <van-field v-model="money"  clearable  class="input"  :placeholder="$t('输入分数')" />
            </div>
          </div>
        </div>

        <div class="wrapper" :class="{active:shopping}" v-if="false">
          <div class="item">
            <span class="label">{{ $t("lottery.selection") }}：</span>
            <div class="bet-number">{{ this.shopchoose }}</div>
            <van-icon name="arrow-down" :class="{ up: !shopping,down:shopping }"
                      @click="shopping ? shopping = false : shopping = true"/>
          </div>
          <div class="item">
            <span class="label">{{ $t("lottery.perNote") }}：</span>
            <div class="amount-wrapper">
              <van-field v-model="money" style="background: rgb(242, 242, 245);" type="digit"
                         :placeholder="$t('lottery.inputMoney')"/>
              <span class="label" style="width: 40PX;margin-left: 5px"></span>
            </div>
          </div>
          <div class="item">
            <div class="part">
              <span>{{ $t("lottery.total") }}</span>
              <span class="number">{{ this.formData.length }}</span>
              <span>{{ $t("lottery.note") }}</span>
            </div>
            <div class="part">
              <span class="number">{{ formatNumber(formData.length * money) }}</span>
              <span><!--{{this.$store.getters.getBaseInfo.currency}}--></span>
            </div>
          </div>
        </div>
      </div>
      <van-popup v-model="jiesuanpage" get-container="body">
        <div class="confirm-order-modal">
          <div class="head van-hairline--bottom">
            <p class="text">{{ $t("lottery.task") }}</p>
          </div>
          <div class="list">
            <div v-for="(v,key) in formData" :key="key" class="lise-item van-hairline--bottom">
              <div class="main">
                <p class="bet-name">{{ names(v.name) }}</p>
                <p class="detail-text">1{{ $t("lottery.note") }}X{{ formatNumber(money) }} = {{ formatNumber(money) }} </p>
              </div>
              <van-icon @click="clearChooes(v.type)" name="close"/>
            </div>
          </div>
          <div class="sub-bar">
            <van-button class="item cancel-btn" type="default" @click="allClear()">
              {{ $t("lottery.empty")}}
            </van-button>
            <van-button class="item sub-btn" type="default" @click="doSub">{{ $t("lottery.verify") }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="active" position="top" :style="{ height: '70%' }">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('msg.下拉即可刷新')"
                          :loosing-text="$t('msg.释放即可刷新')" :loading-text="$t('msg.加载中')">
          <div class="wrapper">
            <div class="item1">
              <div class="left font-weight">{{ $t("lottery.issue") }}</div>
              <div class="right font-weight">{{ $t("lottery.num") }}</div>
            </div>
            <div class="item" v-for="(v,key) in lottery_list" :key="key">
              <div class="left font-weight">{{ v.expect }}</div>
              <div class="right font-weight">
                <div class="kuaisan-ball left">
                  <span class="ballBox" v-for="(item,key) in v.opencode" :key="key">{{ item }}</span>

                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-popup>
    </div>
  </div>
</template>

<script>
var time;
export default {
  data() {
    return {
      jiesuanpage: false,
      choose: {
        "大": false,
        "小": false,
        "单": false,
        "双": false,
      },
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: {},
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      size: "",
      double: "",
      time: 0,
      shopchoose: this.$t("lottery.unselected"),
      gameitem: "",
      formData: [],
      betting_amount: [],
      money: "",
    };
  },
  methods: {

    getBaseInfo() {
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {
        this.betting_amount = res.data.betting_amount;
      })
    },
    back() {
      return window.history.back();
    },
    moneyFun(money) {
      this.money = money
    },
    names(name) {
      if (name == "大") {
        return this.$t("lottery.big");
      } else if (name == "小") {
        return this.$t("lottery.small");
      } else if (name == "单") {
        return this.$t("lottery.single");
      } else if (name == "双") {
        return this.$t("lottery.double");
      }
      return name;
    },
    doSub() {
      if (this.money == "0") {
        this.$toast(this.$t("msg.金额错误！"));
        return false;
      }
      if (this.formData.length == 0) {
        this.$toast(this.$t("msg.请选号！"));
        return false;
      } else if (this.money == "") {
        this.$toast(this.$t("msg.请填写金额!"));
        return false;
      } else {
        if (this.userInfo.money - (this.money * this.formData.length) < 0) {
          this.$toast(this.$t("msg.余额不足，请联系客服充值！"));
          return false;
        } else {
          this.$http({
            method: 'get',
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect
            },
            url: 'game_place_order'
          }).then(res => {
            if (res.code === 200) {
              this.$toast(this.$t("msg." + res.msg));
              this.allClear();
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(this.$t("msg." + res.msg));
            } else if (res.code === 402) {
              this.$toast(this.$t(res.msg));
            }
          })
          return true;
        }
      }
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]['type']] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("lottery.unselected");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    jiesuan() {
      if (this.formData.length == 0) {
        //this.$toast(this.$t("msg.请选号！"));
        return false;
      } else if (this.money == "") {
        //this.$toast(this.$t("msg.请填写金额!"));
        return false;
      } else if (this.money == 0) {
        //this.$toast(this.$t("msg.金额错误！"));
        return false;
      } else {
        this.jiesuanpage ? this.jiesuanpage = false : this.jiesuanpage = true;
      }

    },
    clearChooes(type) {
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]['type']) {
          this.formData.splice(i, 1)
          this.choose[type] = false;
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.names(this.formData[j]['name']);
            this.gameitem = this.formData[j]['type'];
          } else {
            this.shopchoose += "," + this.names(this.formData[j]['name']);
            this.gameitem += "," + this.formData[j]['type'];
          }
        }
      } else {
        this.shopchoose = this.$t("lottery.unselected");
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]['type']) {
            this.formData.splice(i, 1)
          }
        }
      } else if (this.choose[type] === false) {
        this.formData.push({'name': name, 'type': type})
        this.choose[type] = true;
      }
      if (this.formData.length === 1) {
        this.shopping = true;
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.names(this.formData[j]['name']);
            this.gameitem = this.formData[j]['type'];
          } else {
            this.shopchoose += "," + this.names(this.formData[j]['name']);
            this.gameitem += "," + this.formData[j]['type'];
          }
        }
      } else {
        this.shopchoose = this.$t("lottery.unselected");
        this.gameitem = "";
        this.shopping = false;
      }

    },
    check() {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'})
      } else {
        this.getUserInfo();
        this.getLotteryInfo();
        this.getLotteryList();
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("msg.刷新成功！"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },
    getLotteryPeilv() {
      this.$http({
        method: 'get',
        data: {id: this.$route.query.id},
        url: 'lottery_get_peilv'
      }).then(res => {
        if (res.code === 200) {
          this.lottery_peilv_list = res.data;
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },
    getLotteryList() {
      this.$http({
        method: 'get',
        data: {key: this.$route.query.key},
        url: 'lottery_get_one_list'
      }).then(res => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },
    getLotteryInfo() {
      this.$http({
        method: 'get',
        data: {key: this.$route.query.key},
        url: 'lottery_get_info'
      }).then(res => {
        if (res.code === 200) {
          if (parseFloat(this.userInfo.money) < parseFloat(res.data.condition)) {
            this.$toast(this.$t("lottery.kefu"));
            this.$router.push({path: '/Home'})
            return false;
          }
          this.lottery = res.data;
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(this.$t("lottery.drawLottery") + this.lottery.now_expect);
          }

        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })

    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo();
      this.getLotteryInfo();
      this.getLotteryList();
      this.getBaseInfo();

    }
  },
  destroyed() {
    clearInterval(time);
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.setting {
  display: flex;
  align-items: center;
  background: #fff;
  height: 2.5rem;
  box-shadow: 0 0 10px rgba(0,0,0,.05);
  border-bottom: 1px solid #dfe8f6
}

.setting .setMoney {
  width: 100%;
  margin: 0 1.75rem;
  align-items: center;
  display: flex;
  font-size: .875rem
}

.setting .setMoney .keyboardInput {
  width: 11.25rem;
  border: 1px solid #dfe8f6;
  border-radius: .25rem;
  background: #f2f6f9;
  height: 1.875rem;
  display: flex;
  align-items: center;
  padding: 0 .625rem
}

.setting .setMoney .keyboardInput uni-input {
  line-height: 1.25rem;
  color: #ff3900
}

.setting .setMoney .keyboardInput .uni-input-placeholder {
  font-size: .875rem
}

.setting .setMoney .p {
  margin-left: .375rem;
  min-width: 2.8125rem;
  height: 1.9375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: .3125rem;
  color: #000;
  border: .03125rem solid #d91d37;
  position: relative
}
.lotteryMsgBox {
  z-index: 100;
  width: 100%;
  box-shadow: 0 5px 10px rgba(0,0,0,.05)
}

.lotteryMsgBox div {
  box-sizing: content-box
}

.lotteryMsgBox .moreMask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #222;
  opacity: .7;
  z-index: 1
}

.lotteryMsgBox .lotteryMsg {
  position: relative;
  z-index: 3;
  background: #fff;
  width: 100%;
  font-size: .84375rem;
  display: flex;
  box-shadow: 0 .0625rem .3125rem #dfdfdf;
  padding: .625rem 0 40px 0;
  box-sizing: content-box;
}

.lotteryMsgBox .lotteryMsg .top {
  height: 3.59375rem;
  width: 50%;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  text-align: center;
  border-right: .0625rem solid #e6e6e6
}

.lotteryMsgBox .lotteryMsg .top .time {
  font-size: .90625rem;
  color: #2a3563;
  line-height: 1
}

.lotteryMsgBox .lotteryMsg .top .time .sty1 {
  font-size: .90625rem;
  line-height: 1.5;
  font-weight: 700
}

.lotteryMsgBox .lotteryMsg .top .time .sty1 span {
  color: #ff3900;
  font-weight: 700;
  margin: 0 .21875rem
}

.lotteryMsgBox .lotteryMsg .top .time .periods_time {
  color: #ff3900;
  font-size: 1.1875rem;
  line-height: 1.5;
  padding: .46875rem 0 0
}

.lotteryMsgBox .lotteryMsg .openInfo {
  width: 100%;
  height: 3.5625rem;
  font-size: .75rem;
  color: #2a3563
}

.lotteryMsgBox .lotteryMsg .openInfo .foot {
  text-align: center
}

.lotteryMsgBox .lotteryMsg .openInfo .foot>div {
  width: 100%
}

.lotteryMsgBox .lotteryMsg .openInfo .foot>div .periods {
  font-size: .90625rem;
  line-height: 1.5;
  font-weight: 700
}

.lotteryMsgBox .lotteryMsg .openInfo .foot>div .periods span {
  color: #ff3900;
  font-weight: 700;
  margin: 0 .25rem
}

.lotteryMsgBox .lotteryMsg .openInfo .foot>div .periods .vux-x-icon {
  vertical-align: middle;
  transition: .4s
}

.lotteryMsgBox .lotteryMsg .openInfo .foot>div .periods.show .vux-x-icon {
  transform: rotate(180deg)
}

.lotteryMsgBox .more {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  font-size: .84375rem;
  z-index: 2;
  transform: translateY(-100%);
  transition: all .3s
}

.lotteryMsgBox .more.showMore {
  transform: translateY(0)
}

.lotteryMsgBox .more .thead {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 2.5rem;
  line-height: 2.5rem;
  border-bottom: .0625rem solid #e6e6e6;
  background: #dfe8f6;
  font-size: .75rem
}

.lotteryMsgBox .more .thead .periods {
  width: 49%
}

.lotteryMsgBox .more .thead .result {
  width: 51%
}

.lotteryMsgBox .more .thead div {
  display: flex;
  align-items: center;
  justify-content: center
}
.ks .lotteryResult,.more .lotteryResult {
  line-height: 1.8125rem;
  color: #fff;
  font-size: .875rem;
  padding-top: 1vw;
  display: flex;
  align-items: center;
  justify-content: center
}

.ks .lotteryResult div,.more .lotteryResult div {
  margin-right: .25rem;
  width: 1.25rem;
  height: 1.25rem;
  background: linear-gradient(99.09deg, #66bcff 0%, #ec1d25 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center
}

.lotteryMsgBox .more .tbody {
  width: 100%;
  color: #2a3563;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 13rem;
  font-size: .875rem
}

.lotteryMsgBox .more .tbody .more_item {
  height: 1.9375rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #fff
}

.lotteryMsgBox .more .tbody .more_item .periods {
  width: 49%;
  display: flex;
  align-items: center;
  justify-content: center
}

.lotteryMsgBox .more .tbody .more_item .lotteryred {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  width: 51%
}

.lotteryMsgBox .more .tbody .more_item .lotteryred div {
  margin-right: .25rem;
  width: 1.25rem;
  height: 1.25rem;
  background: linear-gradient(99.09deg, #66bcff 0%, #ec1d25 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center
}

.lotteryMsgBox .more .goHistory {
  padding: 1.25rem 0
}

.lotteryMsgBox .more .goHistory div {
  margin: auto;
  width: 9.9375rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: .5rem;
  border: 1px solid #308ee3;
  background: #fff;
  color: #308ee3
}

.ballBox {
  margin-right: 0.25rem;
  width: 1.25rem;
  height: 1.25rem;
  background: linear-gradient(99.09deg, #66bcff 0%, #ec1d25 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.down {
  transition: all .5s;
}

.active {
  border: 0;
}

.sumValueTwoSides .rectangle>p.active {
  background: #ec1d25;
  color: #fff;
  border: #ec1d25;
}

.lottery {
  /*background: url("/img/lotterybg.png") no-repeat top;
  background-size: contain;*/
}

.resBox {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  padding: 8px;
  height: 100%;
  margin-left: 10px;
  width: calc(100% - 37vw);
  box-sizing: border-box;
}

.resBox .resItem {
  width: 9vw;
  height: 9vw;
  line-height: 9vw;
  margin-right: 10px;
  background: linear-gradient(90deg, #8b73e6, #d75db4);
  border-radius: 50%;
  color: #fff;
  text-align: center;
}

.resgardenBox {
  width: 7vw;
  border-radius: 50%;
}

.ressquareBox {
  border-radius: 8px;
  padding: 0 8px;
}

.resgardenBox, .ressquareBox {
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  color: #fff;
  height: 7vw;
  line-height: 7vw;
  text-align: center;
  font-size: 3.1vw;
  font-weight: 700;
  margin-right: 15px;
}

.up {
  transform: rotate(180deg);
  transition: all .5s;
}


.nav-bar .right {
  padding-left: 8px;
  padding-right: 8px;
  color: #fff;
  font-size: 28px;
  border-radius: 10px;
  border: 2px solid #fff;
  line-height: 60px;
}

.record {
  box-shadow: 0 2px 2px 0 #cacaca;
  z-index: 1;
}

.record .period {
  display: flex;
  align-items: center;
  padding: 20px 0;
}

.record .period .cover {
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}

.record .period .period-number {
  flex: 1;
  margin-left: 20px;
  margin-right: 10px;
  height: 50px;
  line-height: 50px;
  font-size: 35px;
  font-weight: 700;
  color: #000;
}

.van-count-down {
  color: #ff253f;
  font-size: 35px;
  margin-top: 10px;
  float: right;
}

.linear-gradient {
  width: 100%;
  height: 2px;
}

.record .recent {
  display: flex;
  align-items: center;
  height: 110px;
}

.kuaisan-ball .left {
  justify-content: flex-start;
}

.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img {
  width: 70px;
  height: 70px;
  margin-right: 30px;
}

.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #000;
}

.kuaisan-ball .res-des.middle {
  width: 10%;
  font-size: 25px;
  //超出一行省略号
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.van-icon {
  font-size: 40px;
}

.down {
  transition: all .5s;
}

.up {
  transform: rotate(180deg);
  transition: all .5s;
}

.wrapper {
  position: relative;
  flex: 1;
  overflow: hidden;
}

.options-bar {
  display: flex;
  align-items: center;
  height: calc(100% - 11vw);
  background: #f2f3f5;
}

.options-bar .game {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.options-bar .game .tips {
  display: flex;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.options-bar .game .tips .odds {
  flex: 1;
  font-size: 35px;
  font-weight: 500;
  color: #ff253f;
}

.options-bar .game .tips .play-tip {
  display: flex;
  align-items: center;
  height: 100%;
}

::v-deep .van-icon-more-o {
  color: #ff253f;
  font-size: 50px;
}

.options-bar .game .tips .play-tip .span-text {
  margin-left: 10px;
  font-size: 35px;
  font-weight: bolder;
  color: #ff253f;
}

.linear-gradient {
  width: 100%;
  height: 2px;
}

.sumValueTwoSides {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 90%;
  margin: 20px  auto;
}

.rectangle.large > p {
  width: 90%;
  margin: auto;
  text-align: center;
  border: .0625rem solid #dfe8f6;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  font-size: 34px;
  border-radius: .5rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #ec1d25;
  margin-top: 30px;
}

.rectangle {
  overflow: hidden;
}

.rectangle.large {
  width: 50%;
}

.rectangle .wrapper {
  position: relative;
  padding: 0 10px;
  background: #fff;
}

.rectangle .wrapper .content {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.rectangle.large .wrapper {
  padding-bottom: 100%;
}

.rectangle .wrapper .content .name-text.large {
  font-size: 45px;
}

.rectangle .wrapper .content .name-text {
  color: #7d7c7c;
  font-weight: bolder;
}

.rectangle .wrapper .content .odd-text.large {
  font-size: 25px;
  margin-top: -30px;
}

.rectangle .wrapper .content .odd-text {
  text-align: center;
  color: #ff253f;
}

.bottom-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100px;
  z-index: 2;
}

.bottom-bar .bar .left, .bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bottom-bar .bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background-color: #fff;
  box-shadow: 0 0 20px 0 #cacaca;
  z-index: 2;
}

.bottom-bar .bar .left, .bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bottom-bar .bar .left .item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100px;
  font-size: 20px;
}

.bottom-bar .bar .left .item .text {
  font-size: 22px;
  color: #7d7c7c;
}

.jixuanico {
  font-size: 45px;
}

.bottom-bar .bar .left .line {
  width: 2px;
  height: 50px;
  background: #dadada;
}

.bottom-bar .bar .mid {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 10px;
}

.bottom-bar .bar .mid .text {
  font-size: 30px;
  font-weight: 500;
  color: #000;
}

.bottom-bar .bar .mid .text.num {
  margin: 0 5px;
  color: #ff253f;
}

.bottom-bar .bar .right {
  padding: 0 30px;
  margin: 0 30px;
  color: #fff;
  background: linear-gradient(99.09deg, #66bcff 0%, #ec1d25 100%);
  font-size: 33px;
  font-weight: 500;
  height: 70px;
  line-height: 70px;
  border-radius: 10px;
}

.rectangle.active .wrapper {
  background-color: #ff253f !important;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-popup {
  position: absolute;
}

::v-deep .van-overlay {
  position: absolute;
  background-color: rgb(70 67 67 / 70%);
}

::v-deep .van-popup--top {
  top: -1px;
}

.wrapper .item {
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-bottom: .0625rem solid #e6e6e6;
  font-size: 32px;
  line-height: 60px;
}


.wrapper .item1 {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 2.5rem;
  line-height: 2.5rem;
  border-bottom: .0625rem solid #e6e6e6;
  background: #dfe8f6;
  font-size: .75rem;
}

.wrapper .item .left {
  width: 40%;
  font-size: 30px;
  text-align: center;
  font-weight: 500;
  color: #000;
}

.font-weight {
  font-weight: 700 !important;
}

.wrapper .item .right {
  flex: 1;
  display: flex;
  font-size: 30px;
  justify-content: center;
  overflow: hidden;
  color: #000;
}

.wrapper .item .kuaisan-ball .left {
  justify-content: flex-start;
}

.wrapper .item .kuaisan-ball {
  margin-left: 20px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrapper .item .kuaisan-ball .res-img {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}

.wrapper .item .kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #000;
}

.wrapper .item .kuaisan-ball .res-des.middle {
  width: 15%;
  font-size: 35px;
}

.play-type-tip {
  position: unset;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 650px;
  height: 700px;
  max-height: 50%;
  z-index: 10;
  border-radius: 30px;
  overflow: hidden;
  background-color: #fff;
  color: #000;
}

.play-type-tip .title {
  line-height: 90px;
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  text-align: center;
  color: #fff;
  font-size: 35px;
  font-weight: 500;
}

.mask {
  background-color: rgb(0 0 0 / 0%);
  animation-duration: 0.35s;
}

.play-type-tip .wrapper {
  height: calc(100% - 10px);
  background-color: transparent;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.play-type-tip .wrapper .item {
  padding: 40px 50px;
  display: flex;
  align-items: flex-start;
}

.play-type-tip .wrapper .item .van-icon {
  color: #e6c3a1;
  font-size: 60px;
}

.play-type-tip .wrapper .item .content .content-title {
  margin-top: 22px;
  font-size: 35px;
  font-weight: 500;
  color: #000;
  line-height: 0px;
}

.play-type-tip .wrapper .item .content .content-detail {
  margin-top: 5px;
  font-size: 22px;
  color: #000;
  line-height: 30px;
}

.play-type-tip .wrapper .item .content {
  flex: 1;
  margin-left: 30px;
}

.rectangle.active .wrapper {
  background-color: #ff253f !important;
}

.rectangle.active .wrapper .name-text, .rectangle.active .wrapper .odd-text {
  color: #fff !important;
}

.bottom-bar .wrapper {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  padding: 10px 20px 10px 20px;
  height: 120px;
  background-color: #fff;
  z-index: 1;
  box-shadow: 0 0 10px 0 #cacaca;
  transition: transform .3s cubic-bezier(.21, 1.02, .55, 1.01);
}

.jifenItemBox {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 4vw 0 0;
}

.jifenItemBox > div {
  color: #a063ee;
  width: 17vw;
  height: 12vw;
  line-height: 11vw;
  text-align: center;
  background: url(/img/hua.png) no-repeat 50%;
  background-size: contain;
  font-size: 3vw;
}

.jifenItemBox > div.active {
  color: #fff;
  background: url(/img/hua_H.png) no-repeat 50%;
  background-size: contain;
}

.bottom-bar .wrapper.active {
  transform: translateY(-100%);
}

.bottom-bar .wrapper .item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 65px;
}

.bottom-bar .wrapper .item .label {
  font-size: 30px;
  line-height: 30px;
  color: #000;
}

.bottom-bar .wrapper .item .bet-number {
  flex: 1;
  margin: 0 16px;
  overflow: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  color: #ff253f;
  font-size: 30px;
  font-weight: 500;
  height: 40px;
  line-height: 40px;
}

.bottom-bar .wrapper .item .amount-wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.van-cell {
  font-size: 30px;
  line-height: 50px;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 16px;
  overflow: hidden;
  color: #323233;
  background-color: initial;
}

 .part {
  margin-right: 20px;
  font-size: 24px;
}

.bottom-bar .wrapper .item .part span {
  font-size: 30px;
  vertical-align: center;
  color: #000;
}

.part .number {
  color: red;
  margin: 0 .25rem;
}

::v-deep .van-field__control {
  color: #ff253f;
}

.confirm-order-modal {
  position: unset;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 20px 30px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 610px;
  height: 680px;
  max-height: 50%;
  z-index: 10;
  background-color: #fff;
  border-radius: 30px;
}

.sumValueTwoSides > div p {
  margin: 0;
}

.confirm-order-modal .head {
  position: relative;
  height: 80px;
}

.confirm-order-modal .head .text {
  padding: 0 20px;
  height: 30px;
  line-height: 10px;
  text-align: center;
  font-size: 35px;
  font-weight: 500;
  color: #7e5678;
}

::v-deep .confirm-order-modal .van-hairline--bottom::after {
  border-bottom-width: 2px;
}

.van-popup--center {
  border-radius: 30px;
}

.confirm-order-modal .list {
  flex: 1;
  padding: 0 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.confirm-order-modal .list .lise-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}

.confirm-order-modal .list .lise-item .main {
  flex: 1;
  overflow: hidden;
}

.confirm-order-modal .list .lise-item .main .bet-name {
  color: #ff253f;
  font-size: 35px;
  font-weight: 500;
  line-height: 0px;
  word-wrap: break-word;
  word-break: break-all;
}

.confirm-order-modal .list .lise-item .main .detail-text {
  line-height: 0px;
  font-size: 25px;
  color: #979799;
}

.confirm-order-modal .list .lise-item {
  color: #ff253f;
}

.confirm-order-modal .sub-bar {
  display: flex;
  align-items: center;
  margin-top: 30px;
  justify-content: space-around;
}

.confirm-order-modal .sub-bar .item {
  min-width: 40%;
  height: 80px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 50px;
  font-size: 35px;
  font-weight: 500;
}

.confirm-order-modal .sub-bar .item.cancel-btn {
  border: 2px solid #979799;
  color: #979799;
  background-color: #fff;
}

.confirm-order-modal .sub-bar .item.sub-btn {
  background: linear-gradient(99.09deg, #66bcff 0%, #ec1d25 100%);
  color: #fff;
  border: 0;
}

.next-number span {
  font-size: 35px;
  font-weight: 700;
  color: #000;
  float: right;
}
</style>
